import React from 'react';

export const getIcons = () => [
  {
    id: 1,
    name: 'reset',
    svg: (
      <>
        <defs />
        <g transform="matrix(0.259, 0.966, -0.966, 0.259, 13.564, 0)">
          <g transform="translate(0)">
            <path
              d="M2.1,6.018H.765a.77.77,0,0,0-.733,1L2.459,11.47c.293.38.791.379,1.164-.149l2.427-4.3a.741.741,0,0,0-.733-1H4.131A4.851,4.851,0,0,1,9.059,2.006a5.021,5.021,0,0,1,5.015,5.015,4.871,4.871,0,0,1-5.015,5.015v2.006A6.94,6.94,0,0,0,16.08,7.021,7.03,7.03,0,0,0,9.059,0,6.932,6.932,0,0,0,2.1,6.018"
              transform="translate(0)"
            />
          </g>
        </g>
      </>
    ),
    viewBox: '0 0 17.726 19.167',
    width: '17.726',
    height: '19.167',
  },
  {
    id: 2,
    name: 'save',
    svg: (
      <>
        <defs />
        <g transform="translate(247.2 23.2)">
          <g transform="translate(0 0)">
            <path
              d="M11.488,10A1.5,1.5,0,0,0,10,11.487V25.512A1.5,1.5,0,0,0,11.488,27H25.513A1.5,1.5,0,0,0,27,25.512V14.037a.638.638,0,0,0-.186-.452l-3.4-3.4A.638.638,0,0,0,22.962,10Zm0,1.275h1.7v5.312a.638.638,0,0,0,.637.638h8.5a.638.638,0,0,0,.637-.637V11.541L25.725,14.3V25.512a.2.2,0,0,1-.213.212H11.488a.2.2,0,0,1-.213-.212V11.487A.2.2,0,0,1,11.488,11.275Zm2.975,0h7.225V15.95H14.463ZM18.5,18.712a2.763,2.763,0,1,0,2.762,2.763A2.772,2.772,0,0,0,18.5,18.712Zm0,1.275a1.487,1.487,0,1,1-1.488,1.487A1.478,1.478,0,0,1,18.5,19.987Z"
              transform="translate(-257 -33)"
            />
          </g>
        </g>
      </>
    ),
    viewBox: '0 0 17.4 17.4',
    width: '17.4',
    height: '17.4',
  },
  {
    id: 3,
    name: 'toggle',
    svg: (
      <>
        <defs />
        <g transform="translate(59.2 -1.8)">
          <g transform="translate(-59 2)">
            <path d="M4.813,1.375V0H0V4.813H1.375V2.338L3.85,4.813l.963-.963L2.338,1.375Z" />
            <path
              d="M3.85,13,1.375,15.475V13H0v4.813H4.813V16.438H2.338l2.475-2.475Z"
              transform="translate(0 -4.063)"
            />
            <path
              d="M16.438,15.475,13.962,13,13,13.962l2.475,2.475H13v1.375h4.813V13H16.438Z"
              transform="translate(-4.063 -4.063)"
            />
            <path
              d="M13,0V1.375h2.475L13,3.85l.962.963,2.475-2.475V4.813h1.375V0Z"
              transform="translate(-4.063)"
            />
          </g>
        </g>
      </>
    ),
    viewBox: '0 0 14.15 14.15',
    width: '14.15',
    height: '14.15',
  },
  {
    id: 4,
    name: 'download',
    svg: (
      <>
        <defs />
        <path
          d="M4.807,1.829c.506,0,.629.293.275.654L1.5,6.134a.913.913,0,0,0,1.29,1.293L5.667,4.545c.239-.239.432-.161.432.174v9.987a.912.912,0,1,0,1.824,0V4.719c0-.336.192-.415.432-.174l2.874,2.883a.913.913,0,0,0,1.29-1.293L8.913,2.478c-.354-.359-.228-.649.275-.649h3.919a.914.914,0,0,0,0-1.829H.914a.914.914,0,0,0,0,1.829Z"
          transform="translate(14.021 15.62) rotate(180)"
        />
      </>
    ),
    viewBox: '0 0 14.021 15.62',
    width: '14.021',
    height: '15.62',
  },
  {
    id: 5,
    name: 'webcomb',
    svg: (
      <>
        <defs />
        <g transform="translate(-39 -28)">
          <g fill="none" transform="translate(39 64) rotate(-90)">
            <path stroke="none" d="M27,0l9,16L27,32H9L0,16,9,0Z" />
            <path
              stroke="none"
              fill="#ffe923"
              d="M 10.75454330444336 3 L 3.442043304443359 16 L 10.75454330444336 29 L 25.24545669555664 29 L 32.55795669555664 16 L 25.24545669555664 3 L 10.75454330444336 3 M 9 0 L 27 0 L 36 16 L 27 32 L 9 32 L 0 16 L 9 0 Z"
            />
          </g>
          <g fill="none" transform="translate(59 51) rotate(-90)">
            <path stroke="none" d="M17.25,0,23,10,17.25,20H5.75L0,10,5.75,0Z" />
            <path
              stroke="none"
              fill="#f3f3f3"
              d="M 7.485580444335938 3 L 3.460580825805664 10 L 7.485580444335938 17 L 15.51441955566406 17 L 19.53941917419434 10 L 15.51441955566406 3 L 7.485580444335938 3 M 5.75 0 L 17.25 0 L 23 10 L 17.25 20 L 5.75 20 L 0 10 L 5.75 0 Z"
            />
          </g>
        </g>
      </>
    ),
    viewBox: '0 0 40 36',
    width: '40',
    height: '30',
  },
  {
    id: 6,
    name: 'console',
    svg: (
      <g
        style={{ mixBlendMode: 'normal' }}
        fill="none"
        fontFamily="none"
        fillRule="nonzero"
        fontSize="none"
        stroke="none"
        strokeDasharray=""
        strokeLinecap="butt"
        strokeWidth="1"
        textAnchor="none">
        <path d="M0,172v-172h172v172z" fill="none" />
        <g fill="#ffffff">
          <path d="M28.66667,22.93333c-6.33533,0 -11.46667,5.13133 -11.46667,11.46667v17.2v91.73333c0.00032,3.1663 2.56703,5.73302 5.73333,5.73333h126.13333c3.1663,-0.00032 5.73302,-2.56703 5.73333,-5.73333v-97.46667v-11.46667c0,-6.33533 -5.13133,-11.46667 -11.46667,-11.46667zM28.66667,51.6h114.66667v86h-114.66667zM51.54401,74.47734c-2.33303,0.00061 -4.43307,1.41473 -5.31097,3.57628c-0.8779,2.16155 -0.3586,4.6395 1.31331,6.26669l13.14636,13.14636l-13.14636,13.14636c-1.49776,1.43802 -2.1011,3.57339 -1.57731,5.58258c0.52378,2.00919 2.09283,3.57824 4.10202,4.10202c2.00919,0.52378 4.14456,-0.07955 5.58258,-1.57732l17.2,-17.2c2.23811,-2.23904 2.23811,-5.86825 0,-8.10729l-17.2,-17.2c-1.07942,-1.10959 -2.56162,-1.73559 -4.10963,-1.73568zM86,108.93333c-2.06765,-0.02924 -3.99087,1.05709 -5.03322,2.843c-1.04236,1.78592 -1.04236,3.99474 0,5.78066c1.04236,1.78592 2.96558,2.87225 5.03322,2.843h34.4c2.06765,0.02924 3.99087,-1.05709 5.03322,-2.843c1.04236,-1.78592 1.04236,-3.99474 0,-5.78066c-1.04236,-1.78592 -2.96558,-2.87225 -5.03322,-2.843z" />
        </g>
      </g>
    ),
    viewBox: '0 0 172 172',
    width: '20',
    height: '20',
  },
  {
    id: 7,
    name: 'upload',
    svg: (
      <g
        style={{ mixBlendMode: 'normal' }}
        fill="none"
        fontFamily="none"
        fillRule="nonzero"
        fontSize="none"
        stroke="none"
        strokeDasharray=""
        strokeLinecap="butt"
        strokeWidth="1"
        textAnchor="none">
        <path d="M0,172v-172h172v172z" fill="none" />
        <g fill="#ffffff">
          <path d="M139.75,143.78125h-107.5c-2.28438,0 -4.03125,-1.74687 -4.03125,-4.03125v-26.875c0,-2.28437 1.74687,-4.03125 4.03125,-4.03125c2.28437,0 4.03125,1.74688 4.03125,4.03125v22.84375h99.4375v-22.84375c0,-2.28437 1.74687,-4.03125 4.03125,-4.03125c2.28438,0 4.03125,1.74688 4.03125,4.03125v26.875c0,2.28438 -1.74687,4.03125 -4.03125,4.03125z" />
          <path d="M86,103.46875c-2.28437,0 -4.03125,-1.74688 -4.03125,-4.03125v-67.1875c0,-2.28438 1.74688,-4.03125 4.03125,-4.03125c2.28437,0 4.03125,1.74687 4.03125,4.03125v67.1875c0,2.28437 -1.74688,4.03125 -4.03125,4.03125z" />
          <path d="M106.15625,56.4375c-1.075,0 -2.01562,-0.40312 -2.82187,-1.20938l-17.33438,-17.33438l-17.33437,17.33438c-1.6125,1.6125 -4.16563,1.6125 -5.64375,0c-1.6125,-1.6125 -1.6125,-4.16562 0,-5.64375l20.15625,-20.15625c1.6125,-1.6125 4.16563,-1.6125 5.64375,0l20.15625,20.15625c1.6125,1.6125 1.6125,4.16562 0,5.64375c-0.80625,0.80625 -1.74687,1.20938 -2.82187,1.20938z" />
        </g>
      </g>
    ),
    viewBox: '0 0 172 172',
    width: '30',
    height: '30',
  },
  {
    id: 8,
    name: 'import',
    svg: (
      <g
        style={{ mixBlendMode: 'normal' }}
        fill="none"
        fontFamily="none"
        fillRule="nonzero"
        fontSize="none"
        stroke="none"
        strokeDasharray=""
        strokeLinecap="butt"
        strokeWidth="1"
        textAnchor="none">
        <path d="M0,172v-172h172v172z" fill="none" />
        <g fill="#ffffff">
          <path d="M32.25,16.125v139.75h96.75v-10.75h-36.70117h-49.29883v-118.25h53.75v32.25h32.25v49.29883l10.75,-10.75v-46.14941l-35.39942,-35.39941zM107.5,34.47559l13.89942,13.89941h-13.89942zM145.125,107.5l-26.875,26.875h21.5v37.625h10.75v-37.625h21.5z" />
        </g>
      </g>
    ),
    viewBox: '0 0 172 172',
    width: '20',
    height: '20',
  },
  {
    id: 9,
    name: 'shortcut',
    svg: (
      <g
        style={{ mixBlendMode: 'normal' }}
        fill="none"
        fontFamily="none"
        fillRule="nonzero"
        fontSize="none"
        stroke="none"
        strokeDasharray=""
        strokeLinecap="butt"
        strokeWidth="1"
        textAnchor="none">
        <path d="M0,172v-172h172v172z" fill="none" />
        <g fill="#ffffff">
          <path d="M100.33333,57.33333c-71.66667,0 -78.83333,86 -78.83333,86c0,0 14.33333,-35.83333 78.83333,-35.83333v28.66667l57.33333,-55.126l-57.33333,-52.374z" />
        </g>
      </g>
    ),
    viewBox: '0 0 172 172',
    width: '20',
    height: '20',
  },
];
